import React, { useEffect, useRef, useState } from "react";
import { Box, Typography } from "@mui/material";
import { keyframes } from "@mui/system";

const companyLogos = [
  "https://ik.imagekit.io/arthgyan/Arthgyan_Web/mfuti.jpeg?updatedAt=1758171396066",
  "https://ik.imagekit.io/arthgyan/Arthgyan_Web/razorpay.png?updatedAt=1758171469662",
  "https://ik.imagekit.io/arthgyan/Arthgyan_Web/mfuti.jpeg?updatedAt=1758171396066",
  "https://ik.imagekit.io/arthgyan/Arthgyan_Web/razorpay.png?updatedAt=1758171469662",
  "https://ik.imagekit.io/arthgyan/Arthgyan_Web/mfuti.jpeg?updatedAt=1758171396066",
  "https://ik.imagekit.io/arthgyan/Arthgyan_Web/razorpay.png?updatedAt=1758171469662",
  "https://ik.imagekit.io/arthgyan/Arthgyan_Web/mfuti.jpeg?updatedAt=1758171396066",
  "https://ik.imagekit.io/arthgyan/Arthgyan_Web/razorpay.png?updatedAt=1758171469662",
];

// Keyframes for infinite scroll
const scrollInfinite = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

const HorizontalScroll = () => {
  const trackRef = useRef(null);
  const [duration, setDuration] = useState(null);

  // Function to recalculate duration
  const calculateDuration = () => {
    if (trackRef.current) {
      const trackWidth = trackRef.current.scrollWidth / 2; // half since duplicated
      const baseSpeed = 60; // pixels per second
      const newDuration = trackWidth / baseSpeed;
      setDuration(newDuration);
    }
  };

  useEffect(() => {
    calculateDuration();
    window.addEventListener("resize", calculateDuration);

    return () => {
      window.removeEventListener("resize", calculateDuration);
    };
  }, []);

  return (
    <Box
      sx={{
        textAlign: "center",
        py: 5,
        px: 2,
        bgcolor: "#fff",

      }}
    >
      {/* Heading */}
      <Typography
        variant="h3"
        sx={{
          fontWeight: 900,
          mb: 3,
          color: "#0D5EA6",
          lineHeight: 1.3,
          width: { xs: "95%", sm: "85%", md: "80%", lg: "70%" },
          mx: "auto",
          fontFamily: "Georgia, serif",
          fontSize: {
            xs: "1.6rem",
            sm: "2rem",
            md: "2.5rem",
            lg: "2.5rem",
          },
        }}
      >
        Trusted by Leading Institution


      </Typography>

      {/* Scrolling Logos */}
      <Box
        sx={{
          width: "100%",
          overflow: "hidden",
          bgcolor: "#fff",
          py: 2,
        }}
      >
        <Box
          ref={trackRef}
          sx={{
            display: "flex",
            gap: { xs: "50px", sm: "70px", md: "150px" },
            width: "max-content",
            alignItems: "center",
            ...(duration && {
              animation: `${scrollInfinite} ${duration}s linear infinite`,
              "&:hover": { animationPlayState: "paused" },
            }),
          }}
        >
          {companyLogos.concat(companyLogos).map((logo, index) => (
            <Box key={index} sx={{ flex: "0 0 auto" }}>
              <Box
                component="img"
                src={`${logo}?tr=w-90,h-45`}
                alt={`logo-${index}`}
                loading="lazy"
                sx={{
                  height: {
                    xs: 30,
                    sm: 40,
                    md: 45,
                  },
                  objectFit: "contain",
                }}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default HorizontalScroll;

